module.exports = __webpack_public_path__ + "static/media/end-work.5835d32d.png";